import { DatePicker } from 'antd'
import type { TimeRangePickerProps } from 'antd'
import { DATE_FORMAT } from './AppDatePicker'

const { RangePicker } = DatePicker

/** 统一日期范围选择 */
export function AppRangePicker(props: TimeRangePickerProps) {
  return (
    <RangePicker
      format={DATE_FORMAT}
      style={{ width: '100%', ...props.style }}
      {...props}
    />
  )
}
